// --------------------------------------------------------------------------
// #143 File upload form field
//     - Enhancement of file upload input
// --------------------------------------------------------------------------
// Authors:     Alix Richards, Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

// jquery plugins
require('../plugins/jquery.validate');
require('../plugins/jquery.validate.unobtrusive');

// expressive annotations
require('../plugins/expressive.annotations.validate');

module.exports = function (options) {
	var context = options.context;
	var fileUploadInput = context.find('[data-binding="file-upload-input"]');
	var fileUploadLabel = context.find('[data-binding="file-upload-label"]');
	var fileUploadControls = context.find('[data-binding="file-upload-controls"]');
	var fileReselectControl = context.find('[data-binding="file-upload-reselect-file"]');
	var fileRemoveControl = context.find('[data-binding="file-upload-remove-file"]');
	var fileUploadText = fileUploadLabel.text();
	var form = context.closest('form');

	function selectFile() {
		fileUploadInput.on('change', function () {
			var filePath = $(this).val();

			if (filePath !== '') {
				var filename = filePath.split(/[\\\/]/).pop(); /// Split at / and \ to handle different file system paths

				fileUploadLabel.addClass('file-selected').text(filename);
				fileUploadControls.addClass('show-controls');
			}

			form.validate().element(fileUploadInput);
		});
	}

	function removeFile() {
		fileRemoveControl.on('click', function (e) {
			e.preventDefault();
			fileUploadInput.val('');
			fileUploadInput.trigger('change');
			fileUploadLabel.text(fileUploadText);
			fileUploadLabel.removeClass('file-selected');
			fileUploadControls.removeClass('show-controls');
		});
	}

	function reselectFile() {
		fileReselectControl.on('click', function (e) {
			e.preventDefault();
			fileUploadInput.trigger('click');
		});
	}

	function getFileExtension(fileName) {
		if (/[.]/.exec(fileName)) {
			return (/[^.]+$/.exec(fileName)[0].toLowerCase()
			);
		}
		return null;
	}

	function validateFile() {
		$.validator.addMethod('filetype', function (value, element, params) {
			for (var i = 0; i < element.files.length; i++) {
				var extension = getFileExtension(element.files[0].name);
				if ($.inArray(extension, params.validtypes) === -1) {
					return false;
				}
			}
			return true;
		});

		$.validator.addMethod('maxfilesize', function (value, element, params) {
			if (element.files.length < 1) {
				return true;
			}

			if (!element.files || !element.files[0].size) {
				return true;
			}

			return element.files[0].size < params.maxbytes;
		}, '');

		$.validator.unobtrusive.adapters.add('filetype', ['validtypes'], function (options) {
			options.rules.filetype = { validtypes: options.params.validtypes.replace(/\s+\./g, '').split(',') };
			options.messages.filetype = options.message;
		});

		$.validator.unobtrusive.adapters.add('maxfilesize', ['maxbytes'], function (options) {
			options.rules.maxfilesize = options.params;
			options.messages.maxfilesize = options.message;
		});

		$.validator.unobtrusive.parse(form);
	}

	function init() {
		selectFile();
		removeFile();
		reselectFile();
		validateFile();
	}

	return {
		init: init
	};
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/file-upload.js
// module id = 256
// module chunks = 0